import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.cmp';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

/** Starts the app. Shared by every entry point. */
export function bootstrapStore(): void {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

    if (environment.production) {
        enableProdMode();
    }
}
